module.exports = __webpack_public_path__ + "static/img/avatar_r_15.f4d4fdea.png";